/** XChaCha20-Poly1305 with a random 24-byte nonce prepended to the ciphertext. */
import { xchacha20poly1305 } from "@noble/ciphers/chacha.js";
import { randomBytes } from "@noble/hashes/utils.js";
import { concat } from "./bytes.js";
export const NONCE_BYTES = 24;
export const KEY_BYTES = 32;
export const TAG_BYTES = 16;
export function seal(key, plaintext, aad) {
    if (key.length !== KEY_BYTES)
        throw new Error("aead key must be 32 bytes");
    const nonce = randomBytes(NONCE_BYTES);
    const ct = xchacha20poly1305(key, nonce, aad).encrypt(plaintext);
    return concat(nonce, ct);
}
export function open(key, box, aad) {
    if (key.length !== KEY_BYTES)
        throw new Error("aead key must be 32 bytes");
    if (box.length < NONCE_BYTES + TAG_BYTES)
        throw new Error("ciphertext too short");
    const nonce = box.subarray(0, NONCE_BYTES);
    const ct = box.subarray(NONCE_BYTES);
    return xchacha20poly1305(key, nonce, aad).decrypt(ct);
}
export function randomKey() {
    return randomBytes(KEY_BYTES);
}
//# sourceMappingURL=aead.js.map